<template>
  <li class="card p-2 mb-2">

    <div v-if="invitation.appContent.type === 'Goal'">
      You got invited to <strong>{{invitation.appContent.cachedName}}</strong>
      by <strong>{{invitation.cachedSenderName}}</strong> ({{invitation.invitedAt|fromNow}}).
      <br />
      <div class="clearfix">
        <img :src="invitation.appContent.cachedPicture" height="64" style="float: left" class="mr-2" />
        <p>{{invitation.personalMessage}}</p>
        <a href="#" @click.stop="onAcceptInvitation(invitation, true)">accept</a> |
        <a href="#" @click.stop="onAcceptInvitation(invitation, false)">decline</a>
      </div>
    </div>

    <div v-else-if="invitation.appContent.type === 'Goalpilot'" class="d-flex">
      <img :src="invitation.cachedProfilePicture" height="64" style="float: left" class="mr-2" />
      <div>
        You got a friend request from
        <strong>{{invitation.cachedSenderName}}</strong>
        ({{invitation.invitedAt|fromNow}}).
        <br />
        <p v-if="invitation.personalMessage" class="p-2 my-2" style="background: #ddd">
          {{invitation.personalMessage}}
        </p>
        <a href="#" @click.stop="onAcceptContact(invitation, true)">accept</a> |
        <a href="#" @click.stop="onAcceptContact(invitation, false)">decline</a>
      </div>
    </div>

    <div v-else>
      TODO
    </div>
  </li>
</template>

<script>
// import { mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    invitation: {
      required: true
    }
  },
  data() {
    return {
    };
  },
  methods: {
    onAcceptInvitation( invitation, accept ) {
      // TODO: move logic to $api
      if ( invitation.appContent.type !== 'Goal' ) {
        console.warn("NOT SUPPORTED")
        return
      }
      let goal_id = invitation.appContent.goalId
      let goal_name = invitation.appContent.cachedName
      this.$api.accept_or_decline_invitation({ goal_id, goal_name, accept })
      .then(() => {

        this.$models.userIncommingInvitation.remove( invitation.$id )
        this.$models.userOutgoingInvitation
          .with({ uid: invitation.senderUserId })
          .remove( invitation.$id )
      })
    },

    onAcceptContact( invitation, accept ) {
      // TODO: move logic to $api
      console.log("onAcceptContact", invitation, accept)

      this.$api.contact_accept_or_decline_friend_request({
        contactUserId: invitation.senderUserId,
        accept: accept
      }).then(() => {

        this.$models.userIncommingInvitation.remove( invitation.$id )
        this.$models.userOutgoingInvitation
          .with({ uid: invitation.senderUserId })
          .remove( invitation.$id )
      })
    },
  }
};
</script>
